import { render, staticRenderFns } from "./salaryRule.vue?vue&type=template&id=0b4fec19&scoped=true&"
import script from "./salaryRule.vue?vue&type=script&lang=js&"
export * from "./salaryRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4fec19",
  null
  
)

export default component.exports